import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {RelayScriptRule} from '../../../classes/RelayScriptRule';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {RelayScriptRuleModifier} from '../../../enums/RelayScriptRuleModifier';
import {RelayBoardService} from '../../../services/relay-board.service';
import {RelayBoard} from '../../../classes/RelayBoard';
import {TimePeriod} from '../../../classes/TimePeriod';
import {TimePeriodService} from '../../../services/time-period.service';
import {OfficeService} from '../../../services/office.service';
import {Office} from '../../../classes/Office';
import {Sensor} from '../../../classes/Sensor';
import {SensorService} from '../../../services/sensor.service';
import {Relay} from '../../../classes/Relay';
import {RelayService} from '../../../services/relay.service';

@Component({
  selector: 'app-relay-script-rule-edit',
  styleUrls: ['./relay-script-rule-edit.component.scss'],
  templateUrl: './relay-script-rule-edit.component.html',
  encapsulation: ViewEncapsulation.None
})
export class RelayScriptRuleEditComponent implements OnInit {

  @Input() relayScriptRule: RelayScriptRule;

  protected errorMessage: string;
  protected relayScriptRuleForm: FormGroup;
  protected relayBoards: RelayBoard[];
  protected timePeriods: TimePeriod[];
  protected modifiers: string[];
  protected offices: Office[];
  protected sensors: Sensor[];
  protected relays: Relay[];

  constructor(private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private relayBoardService: RelayBoardService,
              private timePeriodService: TimePeriodService,
              private officeService: OfficeService,
              private sensorService: SensorService,
              private relayService: RelayService) {}

  ngOnInit(): void {

    this.modifiers = Object.keys(RelayScriptRuleModifier);

    this.officeService.getAll().subscribe({
      next: response => this.offices = response
    });

    this.relayBoardService.getAll().subscribe({
      next: (response: RelayBoard[]) => this.relayBoards = response,
      error: err => console.log(err.error) // TODO handle error
    });

    this.timePeriodService.getAll().subscribe({
      next: (response: TimePeriod[]) => this.timePeriods = response,
      error: err => console.log(err.error) // TODO handle error
    });

    this.sensorService.getAll().subscribe({
      next: (response: Sensor[]) => this.sensors = response,
      error: err => console.log(err.error) // TODO handle error
    });

    if (this.relayScriptRule) {
      this.relayScriptRuleForm = this.formBuilder.group({
        id: [this.relayScriptRule.id],
        officeId: [this.relayScriptRule.officeId],
        timePeriodId: [this.relayScriptRule.timePeriodId, Validators.required],
        relayBoardId: [this.relayScriptRule.relayBoardId, Validators.required],
        modifier: [this.relayScriptRule.modifier, Validators.required],
        sensorId: [this.relayScriptRule.sensorId, Validators.required],
        isActive: [false],
        relayList: this.formBuilder.array(this.relayScriptRule.relayList),
        relayBoardId1: [null],
        relayId: [null],
        isEnabled: [false]
      });
    } else {
      this.relayScriptRuleForm = this.formBuilder.group({
        id: [null],
        officeId: [null],
        timePeriodId: [null, Validators.required],
        relayBoardId: [null, Validators.required],
        modifier: [RelayScriptRuleModifier.NONE, Validators.required],
        sensorId: [null, Validators.required],
        isActive: [false],
        relayList: this.formBuilder.array([]),
        relayBoardId1: [null],
        relayId: [null],
        isEnabled: [false]
      });
    }

    this.relayScriptRuleForm.controls.officeId.valueChanges.subscribe(value => {
      this.relayBoardService.getAllByOffice(value).subscribe(response => {
        this.relayBoards = response;
        this.relayScriptRuleForm.controls.sensorId.setValue(null);
        this.relayScriptRuleForm.controls.relayId.setValue(null);
      });
    });

    this.relayScriptRuleForm.controls.relayBoardId.valueChanges.subscribe(value => {
      this.sensorService.getByRelayBoard(value).subscribe(response => this.sensors = response);
    });

    this.relayScriptRuleForm.controls.relayBoardId1.valueChanges.subscribe(value => {
      if (!value) {
        this.relayService.getAll().subscribe(response => this.relays = response);
      } else {
        this.relayService.getByRelayBoard(value).subscribe(response => this.relays = response);
      }
    });
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }

  get relayList(): FormArray {
    return this.relayScriptRuleForm.controls.relayList as FormArray;
  }

  addRelay(): void {
    const relayBoardId = this.relayScriptRuleForm.controls.relayBoardId1.value;
    const relayId = this.relayScriptRuleForm.controls.relayId.value;

    if (!relayBoardId || !relayId) {
      return;
    }

    const relayForm = this.formBuilder.group({
      relayBoardId: [relayBoardId, Validators.required],
      relayBoardName: [this.getRelayBoardName(relayBoardId)],
      relayId: [relayId, Validators.required],
      relayName: [this.getRelayName(relayId)],
      isEnabled: [this.relayScriptRuleForm.controls.isEnabled.value, Validators.required]
    });

    this.relayList.push(relayForm);

    this.relayScriptRuleForm.controls.relayBoardId1.setValue(null);
    this.relayScriptRuleForm.controls.relayId.setValue(null);
    this.relayScriptRuleForm.controls.isEnabled.setValue(false);
  }

  removeRelay(i: number): void {
    this.relayList.removeAt(i);
  }

  getRelayBoardName(relayBoardId: number): string {
    return this.relayBoards.find(relayBoard => relayBoard.id === +relayBoardId).name;
  }

  getRelayName(relayId: number): string {
    return this.relays.find(relay => relay.id === +relayId).name;
  }
}
